module.exports = __webpack_public_path__ + "static/media/access_types.08dd2736.jpg";